import {
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@mui/material";
import { useCommands } from "@remirror/react";
import { CommandMenuItem } from "@remirror/react-ui";
import { useState } from "react";
import { IframeExtension } from "remirror/extensions";

export const YoutubeButton = () => {
  const [video, setVideo] = useState<string>();
  const [isEditing, setIsEditing] = useState(false);
  const commands = useCommands<IframeExtension>();

  return (
    <>
      <CommandMenuItem
        commandName="insertVideo"
        label="Insert youtube video"
        icon="videoLine"
        enabled={true}
        onSelect={() => setIsEditing(true)}
        displayDescription={false}
      />
      <Dialog
        open={isEditing}
        onClose={() => setIsEditing(false)}
        maxWidth="md"
      >
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Youtube video"
            fullWidth
            variant="standard"
            value={video}
            onChange={(e) => setVideo(e.target.value)}
            helperText="Paste the video id (_P1TQmG9-JQ) or full link (https://www.youtube.com/watch?v=_P1TQmG9-JQ)"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsEditing(false)}>Cancel</Button>
          <Button
            variant="outlined"
            color="primary"
            disabled={!video}
            onClick={() => {
              commands.addYouTubeVideo({ video });
              setIsEditing(false);
            }}
          >
            Insert
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
